/* eslint-disable */
import React, { useEffect } from "react";
import { connect } from "react-redux";
// import PromoImageCard from "../../components/shared/PromoImageCard";
import { nonClaimsModules } from "../../constants/SMEModulesToMatchOn";
// import Content from "../../content/Content";
import Store from "../../content/Store";
import DateHelper from "../../helpers/DateHelper";
// import HomeCard from "./HomeCard";
import HomeHeadingActionButton from "./HomeHeadingActionButton";
import HomeHero from "./HomeHero";
// import ThumbnailList from "./ThumbnailList";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";
import { Layouts } from "../../constants/Constants";
// import LinkAPlan from "./LinkAPlan";
import {
  loadOptionValues,
  loadPreferencekeys,
} from "../../actions/policy/policyActions";
// import { stripGP247 } from "../../content/ContentHelper";
import navigationRight from "../../assets/img/carousel/navigate_next.png";
import navigateLeft from "../../assets/img/carousel/navigate_before.png";
import styles from "../../assets/css/modules/carousel/home-carousel.css";
import {    
  setCarouselCount  
} from "../../actions/policy/policyActions";
import HomeCarousel from "./HomeCarousel";

export const mapStateToHome = ({ policyReducer = {}, layoutReducer = {}, unreadMessagesReducer={},carouselReducer={} }) => {
  const selectedPolicy = policyReducer.selectedPolicy;
  const isInternational = selectedPolicy && selectedPolicy.IsInternational;
  const isSaga = selectedPolicy && selectedPolicy.IsSaga;
  const isLapsed = selectedPolicy && selectedPolicy.IsLapsed;
  const isLargeCorporate = selectedPolicy && selectedPolicy.IsLargeCorporate;
  const carouselCount =carouselReducer.carouselCount;
  const totalCount =carouselReducer.slideTotal;
  return {
    selectedPolicy,
    policyDetails: policyReducer.policyDetails,
    isLapsed,
    carouselCount,
    totalCount,
    isInternational,
    shouldShowClaims: shouldShowIfAllSMEModulesDontMatch(
      selectedPolicy,
      nonClaimsModules
    ),
    isSME: selectedPolicy && selectedPolicy.IsSME,
    isHol: layoutReducer.layout === Layouts.HOL,
    isIndividual: selectedPolicy && selectedPolicy.IsIndividual,
    isSaga,
    isLargeCorporate,
    // shouldRenderProactiveHealthGatewayPromo:
    //   selectedPolicy && selectedPolicy.IsSMEModular,
    shouldRenderHealthStorePromo: !(isInternational || isSaga || isLapsed),
    shouldRenderCheck4CancerPromo: !isLapsed && !isInternational,
    shouldRenderAskMedicalExpertPromo: !isLapsed,
    isRemoveThriveOffer: window.axa.isRemoveThriveOffer,
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    featureFlagEP : unreadMessagesReducer.featureFlagEP
  };
};

const mapDispatchToProps = dispatch => {

  return {

    loadOptionValues: (MembershipNumber) => dispatch(loadOptionValues(MembershipNumber)),

    loadPreferencekeys: () => dispatch(loadPreferencekeys()),
    setCarouselCount: (slideCount) => dispatch(setCarouselCount(slideCount)),
  };

};

// const shouldAlignHealthStorePromoLeft = ({
//   shouldRenderProactiveHealthGatewayPromo
// }) => {
//   return !shouldRenderProactiveHealthGatewayPromo;
// };

// const shouldAlignHealthStorePromoAnyLeft = ({

//   shouldRenderProactiveHealthGatewayPromo,
//   shouldRenderHealthStorePromo
// }) => {
//   return (
//     (shouldRenderProactiveHealthGatewayPromo && shouldRenderHealthStorePromo) ||
//     (!shouldRenderProactiveHealthGatewayPromo && !shouldRenderHealthStorePromo)
//   );
// };

// const shouldAlignCheck4CancerPromoLeft = ({
//   shouldRenderProactiveHealthGatewayPromo,
//   shouldRenderHealthStorePromo
// }) => {
//   return (
//     (shouldRenderProactiveHealthGatewayPromo && shouldRenderHealthStorePromo) ||
//     (!shouldRenderProactiveHealthGatewayPromo && !shouldRenderHealthStorePromo)
//   );
// };
// const shouldAlignCheck4CancerPromoAnyLeft = ({
//   shouldRenderProactiveHealthGatewayPromo
// }) => {
//   return !shouldRenderProactiveHealthGatewayPromo;
// };

// const shouldAlignAskMedicalExpertPromoLeft = ({
//   shouldRenderProactiveHealthGatewayPromo,
//   shouldRenderHealthStorePromo,
//   shouldRenderCheck4CancerPromo
// }) => {
//   return (
//     (!shouldRenderProactiveHealthGatewayPromo &&
//       !shouldRenderHealthStorePromo &&
//       !shouldRenderCheck4CancerPromo) ||
//     (shouldRenderProactiveHealthGatewayPromo &&
//       shouldRenderHealthStorePromo &&
//       !shouldRenderCheck4CancerPromo) ||
//     (!shouldRenderProactiveHealthGatewayPromo &&
//       shouldRenderHealthStorePromo &&
//       shouldRenderCheck4CancerPromo)
//   );
// };


export const Home = function (props) {
  useEffect(() => {
    props.loadOptionValues(props.selectedPolicy && props.selectedPolicy.MembershipNumber);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.MembershipNumber]);

  useEffect(() => {
    props.loadPreferencekeys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const prevSlide = () => {
    // const { currentSlideIndex } = this.props.carouselCount;
    const newSlide = props.carouselCount > 0 ?props.carouselCount - 1 : props.totalCount - 1;
    // this.setState({ currentSlideIndex: newSlide });
    props.setCarouselCount(newSlide);
};
const nextSlide = () => {
    // const { currentSlideIndex } = this.props.carouselCount;
    const newSlide = props.carouselCount < props.totalCount - 1 ?props.carouselCount + 1 : 0;
    // this.setState({ currentSlideIndex: newSlide });
    props.setCarouselCount(newSlide);
};
// console.log(props.carouselCount);
// console.log(props.totalCount);
  return (
    <div className="home">

      <HomeHero
        MembershipNumber={
          props.selectedPolicy && props.selectedPolicy.MembershipNumber
        }
        RenewalDate={
          props.selectedPolicy &&
          DateHelper.getRenewalFormat(props.selectedPolicy.RenewalDate)
        }
        ShowRenewal={
          props.selectedPolicy && props.selectedPolicy.ShowRenewalInformation
        }
        LastLoggedInDate={
          props.policyDetails &&
          DateHelper.getDateInStringFormat(props.policyDetails.LastLoginDate)
        }
        LastLoggedInTime={
          props.policyDetails &&
          DateHelper.getTimeInStringFormat(props.policyDetails.LastLoginDate)
        }
        NotificationCount="4"
        MessagesCount="0"
        ProductType={props.selectedPolicy && props.selectedPolicy.ProductType}
        page={'home'}
      />
      <div className="container">
        <div className="row align-items-center">
          <div className="leftArrow">
            <img
              src={navigateLeft}
              alt="navigation arrow"
              onClick={prevSlide}
              className={props.carouselCount === 0 ? styles.prevSlide : styles.prevSlideActive}
            /> </div>
          <div className="cardCarousel">
            {props.isLapsed ? null : <HomeCarousel />}
          </div>
          <div className="rightArrow">
            <img
              src={navigationRight}
              alt="navigation arrow"
              className={props.carouselCount + 4 > props.totalCount ? styles.prevSlide : styles.prevSlideActive}
              onClick={nextSlide}
            />
          </div>
        </div>
      </div>
      {/* <LinkAPlan /> */}
      <div className="container"> 
        {/* {!props.isHol && props.shouldRenderCheck4CancerPromo ? (
          <React.Fragment>
            <div className="row">
              <div id="check4CancerPromo" className="col-sm-12">
                <PromoImageCard
                  ImgSrc={Store.Home.Cards.Check4Cancer.IconSrc}
                  ImgSrcMobile={Store.Home.Cards.Check4Cancer.IconSrcMobile}
                  Heading={Store.Home.Cards.Check4Cancer.Heading}
                  Description={Store.Home.Cards.Check4Cancer.Description}
                  LinkText={Store.Home.Cards.Check4Cancer.LinkText}
                  LinkTo={Store.Home.Cards.Check4Cancer.LinkTo}
                  aria-label={Store.Home.Cards.Check4Cancer.AriaLabel}
                  LeftImage={shouldAlignCheck4CancerPromoAnyLeft(props)}
                />
              </div>
            </div>
          </React.Fragment>
        ) : null}

        {!props.isHol && props.shouldRenderHealthStorePromo ? (
          <div className="row">
            <div id="healthStorePromo" className="col-sm-12">
              <PromoImageCard
                ImgSrc={Store.Home.Cards.HealthStore.IconSrc}
                ImgSrcMobile={Store.Home.Cards.HealthStore.IconSrcMobile}
                Heading={Store.Home.Cards.HealthStore.Heading}
                Description={Store.Home.Cards.HealthStore.Description}
                LinkText={Store.Home.Cards.HealthStore.LinkText}
                LinkTo={Store.Home.Cards.HealthStore.LinkTo}
                LeftImage={shouldAlignHealthStorePromoAnyLeft(props)}
              />
            </div>
          </div>
        ) : null}

        {props.isHol && props.shouldRenderHealthStorePromo ? (
          <div className="row">
            <div id="healthStorePromo" className="col-sm-12">
              <PromoImageCard
                ImgSrc={Store.Home.Cards.HealthStore.IconSrc}
                ImgSrcMobile={Store.Home.Cards.HealthStore.IconSrcMobile}
                Heading={Store.Home.Cards.HealthStore.Heading}
                Description={Store.Home.Cards.HealthStore.Description}
                LinkText={Store.Home.Cards.HealthStore.LinkText}
                LinkTo={Store.Home.Cards.HealthStore.LinkTo}
                LeftImage={shouldAlignHealthStorePromoLeft(props)}
              />
            </div>
          </div>
        ) : null}

        {props.isHol && props.shouldRenderCheck4CancerPromo ? (
          <React.Fragment>
            <div className="row">
              <div id="check4CancerPromo" className="col-sm-12">
                <PromoImageCard
                  ImgSrc={Store.Home.Cards.Check4Cancer.IconSrc}
                  ImgSrcMobile={Store.Home.Cards.Check4Cancer.IconSrcMobile}
                  Heading={Store.Home.Cards.Check4Cancer.Heading}
                  Description={Store.Home.Cards.Check4Cancer.Description}
                  LinkText={Store.Home.Cards.Check4Cancer.LinkText}
                  LinkTo={Store.Home.Cards.Check4Cancer.LinkTo}
                  aria-label={Store.Home.Cards.Check4Cancer.AriaLabel}
                  LeftImage={shouldAlignCheck4CancerPromoLeft(props)}
                />
              </div>
            </div>
          </React.Fragment>
        ) : null}

        {props.shouldRenderAskMedicalExpertPromo ? (
          <React.Fragment>
            <div className="row">
              <div id="askMedicalExpertPromo" className="col-sm-12">
                <PromoImageCard
                  ImgSrc={Store.Home.Cards.AskMedExpert.IconSrc}
                  ImgSrcMobile={Store.Home.Cards.AskMedExpert.IconSrcMobile}
                  Heading={Store.Home.Cards.AskMedExpert.Heading}
                  Description={Store.Home.Cards.AskMedExpert.Description}
                  LinkText={Store.Home.Cards.AskMedExpert.LinkText}
                  LinkTo={Store.Home.Cards.AskMedExpert.LinkTo}
                  LeftImage={shouldAlignAskMedicalExpertPromoLeft(props)}
                />
              </div>
            </div>
            {
              (props.isHol && props.selectedPolicy.IsChildOnlyPolicy) || props.isSaga ? null :
                <div className="row">
                  <div className="col-sm-12">
                    <div className="box home-card">
                      <Content name={Store.Home.ThumbnailList.ListItems}>
                        {(listItems) => (
                          <ThumbnailList
                            Heading={Store.Home.ThumbnailList.Heading}
                            Items={stripGP247(props.selectedPolicy.IsChildOnlyPolicy, listItems)}
                          />
                        )}
                      </Content>
                    </div>
                  </div>
                </div>
            }
          </React.Fragment>
        ) : null} */}

        <div className="row">
          <div className="col-sm-12">
            <HomeHeadingActionButton
              Heading={Store.Home.ActionButton.Heading}
              LinkText={Store.Home.ActionButton.LinkText}
              LinkTo={Store.Home.ActionButton.LinkTo}
              buttonType="secondaryBlueButton"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToHome, mapDispatchToProps)(Home);